<!--
 * @Author: MouXiaowei
 * @Date: 2022-07-07 09:57:17
 * @Description: 中石油优惠券详情
-->

<template>
  <div class="content">
    <div class="coupon-box">
        <div class="coupon-content">
            <div class="coupon-content-left">
                <div class="coupon-content-left-title">{{showTitle}}</div>
                <div class="coupon-content-left-time" v-if="startTime != null && startTime.length > 0">{{ startTime + ' - ' + endTime}}</div>
            </div>
            <div class="coupon-content-right" v-if="batchMoney > 0">
                <div class="coupon-content-right-amount">
                    <div class="coupon-content-right-amount-tip"><span>¥</span></div>
                    <div class="coupon-content-right-amount-value"><span>{{ batchMoney }}</span></div>
                </div>
                <div class="coupon-content-right-rule">{{ '满' + limitMoney + '可用' }}</div>
            </div>
        </div>
    </div>

    <div class="qrcode-box" v-if="codeUrl != null && codeUrl.length > 0">
        <div class="qrcode-content">
            <qrcode class="qrcode-content-qrcode" :value="codeUrl" />
        </div>
        <div class="qrcode-refresh" @click="queryDetail">
            <img class="qrcode-refresh-icon" src="@/assets/images/icon_qrcode_refresh.png" />
            <div class="qrcode-refresh-text">点击刷新二维码</div>
        </div>
    </div>

    <div class="rule-box" v-if="usedDes != null && usedDes.length > 0">
        <div class="rule-title">使用须知</div>
        <div class="rule-content">{{usedDes}}</div>
    </div>
  </div>
</template>
<script>

import { setStore } from '@/utils/index'
import Qrcode from 'vue-qrcode'
// import { Toast } from 'vant'
import { getSnpDetail } from '@/api/coupon'

export default {
  name: 'couponSnpDetail',
  components: {
    Qrcode
  },
  data () {
    return {
      couponId: '',
      codeUrl: '',
      timer: null, // 轮询支付结果定时器
      timerLoopCount: 0, // 定时器轮询次数
      showTitle: '', // 券标题
      usedDes: '',
      startTime: '', // 开始时间
      endTime: '', // 结束时间
      batchMoney: '', // 金额
      limitMoney: '' // 限制额度
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  mounted () {
    const accessToken = this.$route.query.accessToken
    if (accessToken) {
      setStore('token', accessToken)
    }
    const couponId = this.$route.query.couponId
    this.couponId = couponId
    this.queryDetail()
  },
  methods: {
    queryDetail () {
      const queryList = {
        couponsUsersId: this.couponId
      }
      getSnpDetail(queryList).then(res => {
        if (res && res.data) {
          const datas = res.data.result
          this.codeUrl = datas.checkCode
          this.showTitle = datas.showTitle
          this.startTime = datas.startTime
          this.endTime = datas.endTime
          this.batchMoney = datas.batchMoney
          this.limitMoney = datas.limitMoney
          this.usedDes = datas.usedDes
          this.end()
          this.timerLoopCount = 0
          this.start()
        }
      })
    },
    // 开启定时器
    start () {
      this.timer = setInterval(() => {
        this.timerLoopCount += 1
        if (this.timerLoopCount >= 1) {
          this.queryDetail()
        }
      }, 60000)
    },
    // 结束定时器
    end () {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
    background-color: #f6f6f6;
}
.rule-box {
    background-color: #fff;
    margin-top: 10px;

    .rule-title {
        padding-top: 12px;
        margin-left: 15px;
        font-weight: 500;
        font-size: 14px;
        color: #282828;
        line-height: 20px;
    }
    .rule-content {
        margin: 10px 15px;
        font-size: 12px;
        color: #282828;
        text-align: justify;
        line-height: 17px;
    }
}
.qrcode-box {
    height: 250px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .qrcode-content-qrcode {
        width: 200px;
        height: 200px;
    }

    .qrcode-refresh {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        &-icon {
            width: 16px;
            height: 16px;
        }
        &-text {
            margin-left: 6px;
            font-size: 12px;
            color: #757575;
            line-height: 24px;
        }
    }
}
.coupon-box {
    height: 110px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #fff;

    .coupon-content {
        width: 345px;
        height: 90px;
        display: flex;
        flex-direction: row;
        align-items: center;
        background: url('https://bjqd-app.oss-cn-qingdao.aliyuncs.com/appweb/coupon/coupon_snp_bg.png') no-repeat;

        .coupon-content-left {
            width: 255px;
            height: 90px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &-title {
                line-height: 21px;
                font-weight: 500;
                font-size: 15px;
                color: #A45304;
                text-align: center;
            }
            &-time {
                margin-top: 4px;
                line-height: 16px;
                font-weight: 500;
                font-size: 11px;
                color: #A45304;
                text-align: center;
            }
        }

        .coupon-content-right {
            width: 90px;
            height: 90px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &-amount {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: flex-end;

                &-tip {
                    line-height: 30px;
                    font-size: 14px;
                    color: #9A571F;
                    font-weight: 550;
                    align-self: flex-end;
                }
                &-value {
                    margin-left: 4px;
                    line-height: 40px;
                    font-weight: 550;
                    font-size: 36px;
                    color: #9A571F;
                }
            }

            &-rule {
                margin-top: 4px;
                font-weight: 500;
                font-size: 11px;
                color: #9A571F;
                line-height: 16px;
            }
        }
    }
}
</style>
